<script>
const packageJSON = require('root/package.json')
export default {
    props: {
        hideClose: Boolean,
        platform: String
    },
    data() {
        return {
            checked: false,
            version: packageJSON.version,
        }
    },
    computed: {
        platformStr() {
            if (this.platform) {
                return `【${this.platform}】`
            } else {
                return ''
            }
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        confirm() {
            this.$emit('confirm')
        }
    }
}
</script>
<template>
<div class="Productinformation">
    <AboutDialog showConfirm :hide-close="hideClose" :selfLogo="true" btn-text="我知道了" title="视感知觉训练软件【注册信息】" @close="$emit('close')" @confirm="$emit('confirm', checked)">
        <div class="container_box">
            <div class="content">
                <p style="margin-bottom: 6px;" class="text"><span>注册证编号</span>粤械注准20202210139</p>
                <p style="margin-bottom: 6px;" class="text"><span>注册人姓名</span>珠海广目锐视医疗科技有限公司</p>
                <p style="margin-bottom: 6px;" class="text"><span>产品名称</span>视感知觉训练软件</p>
                <p style="margin-bottom: 6px;" class="text"><span>型号、规格</span>GMRS-RS-2019</p>
                <p style="margin-bottom: 6px;" class="text"><span>注册人住所</span>珠海市高新区金鼎科技工业园金峰西路29号C区一楼120室</p>
                <p style="margin-bottom: 6px;" class="text"><span>结构及组成</span>主要由精细刺激训练，视觉技巧训练，双眼视功能训练，</p>
                <p style="margin-bottom: 6px;" class="text"><span></span>Gabor训练，对比敏感度训练，信息提取训练6个模块组成</p>
                <p style="margin-bottom: 6px;" class="text"><span>适应范围</span>适用于儿童轻、中度弱视及融合功能不足的治疗</p>
                <el-checkbox style="margin-top: 40px;" v-model="checked">以后不再显示</el-checkbox>
            </div>
        </div>

    </AboutDialog>

</div>
</template>

<style lang="scss">
.Productinformation {
    .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #4F64AB;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #4F64AB;
        border-color: #4F64AB;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #4F64AB;
    }
}
</style>

<style lang="scss" scoped>
.Productinformation {

    .container_box {
        margin-bottom: 25px;
        height: 260px;

        .text {
            >span {
                color: #646464;
                width: 90px;
                display: inline-block;
            }

            font-size:14px;
            font-weight:400;
            color:#00C1DE;
            line-height:20px;
        }

        .line {
            width: 309px;
            height: 2px;
            background-color: #EBEBEB;
        }
    }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/Productinformation.vue